var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('core-toolbar'),_c('core-drawer',{attrs:{"background":require("@/assets/images/sidebar.jpg"),"title":"Einhell Service","logo":require("@/assets/small_logo.jpg"),"items":_vm.sidebarItems}}),_c('core-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }